import React, { useEffect, useState } from "react";
import { Row, Col, Form, Typography, Card, Tooltip, Button, Input, Switch, Modal, notification } from "antd";
import { EditOutlined, DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import api from "../../services/api";
import { useStateValue } from "../../state";
import { manutencaoActions } from "../../actions";
import { HasValue, isObjetoDiffVazio } from "../../services/funcoes";
import { ModalCliente, ModalBuscaPessoaAutorizada, ModalTransferencia, ModalTransportadora } from "../../components/modals/";
import { ModalImagemQr } from "../../components/modals/";

export default function DadosCliente({ setAbreModalAntecipacao, dadosAntecipacao, setDadosAntecipacao, possuiAntecipacao, setPossuiAntecipacao, cliente, setCliente, setFrete,
    switchState, setSwitchState, setEnderecoDestino, formulario, whatsApp, setWhatsApp, setIgnorarDadosClienteDfe, setControleSwitchEmail, setControleSwitchWhats }) {

    const [{ manutencao }, dispatch] = useStateValue();
    const [openModalBuscaCliente, setOpenModalBuscaCliente] = useState(false);
    const [openModalBuscaPessoaAutorizada, setOpenModalBuscaPessoaAutorizada] = useState(false);
    const [dadosEmail, setDadosEmail] = useState(false);
    const [dadosWhats, setDadosWhats] = useState(false);
    const [dadosCliente, setDadosCliente] = useState({});
    const [openModalTransportadora, setOpenModalTransportadora] = useState(false);
    const [numeroWhats, setNumeroWhats] = useState('');
    const [email, setEmail] = useState('');
    const [conectado, setConectado] = useState(false);
    const [switchDadosConsumidor, setSwitchDadosConsumidor] = useState(false);
    const [exibirQr, setExibirQR] = useState(false);
    const [temporizador, setTemporizador] = useState(60);
    const [base64Image, setBase64Image] = useState('');

    const handleKeyPress = (event) => {
        if (event.key === "F2") {
            setOpenModalBuscaCliente(true)
        }
    }
    const onCloseModalQr = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                setExibirQR(false);
                setTemporizador(temporizador);

            }
        });
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        }
    }, [])

    useEffect(() => {
        if (!!manutencao.dados && !!manutencao.dados.cliente && isObjetoDiffVazio(manutencao.dados.cliente) && (!!!cliente.pes_id || cliente.pes_id !== manutencao.dados.cliente.pes_id)) {
            setCliente(manutencao.dados.cliente);
            setDadosCliente(manutencao.dados.cliente);
            setDadosAntecipacao([]);
            if (manutencao.dados.cliente.cli_naogerardadosfiscais) {
                setSwitchDadosConsumidor(true);
                setIgnorarDadosClienteDfe(true);
            }
        }
    }, [manutencao.dados]);

    function switchEmail() {
        setDadosEmail(!dadosEmail);
        setControleSwitchEmail(!dadosEmail);

        if (!dadosEmail) {
            const emailsCliente = manutencao?.dados?.cliente?.emails;
            const emailsManutencao = manutencao?.dados?.emails;

            if ((emailsCliente?.length > 0) || (emailsManutencao?.length > 0)) {
                const email = emailsCliente?.[0]?.pem_email || emailsManutencao?.[0]?.pem_email;

                if (email) {
                    setEmail(email);
                    formulario.setFieldsValue({ formEmail: email });
                    dispatch({ type: manutencaoActions.CHANGE, data: { dados: { ...manutencao.dados, email } } });
                }
            }
        } else {
            formulario.setFieldsValue({ formEmail: "" });
            dispatch({ type: manutencaoActions.CHANGE, data: { dados: { ...manutencao.dados, email: '' } } });
        }
    };

    function switchWhats() {
        setDadosWhats(!dadosWhats);
        setControleSwitchWhats(!dadosWhats);
        let enviaWhats = false;

        if (!dadosWhats) {
            if (manutencao?.dados?.cliente != null) {
                const numeroWhats = manutencao.dados.cliente.telefones?.[0]?.psc_numero ?? "";
                if (numeroWhats) {
                    enviaWhats = true;
                }
                setNumeroWhats(numeroWhats);
                formulario.setFieldsValue({ formWhats: numeroWhats })
                setWhatsApp(true);
                dispatch({ type: manutencaoActions.CHANGE, data: { dados: { ...manutencao.dados, ...{ numeroWhats: numeroWhats, enviaWhats: enviaWhats } } } });
                enviarWhats(numeroWhats);
            }
        } else {
            setWhatsApp(false);
            dispatch({ type: manutencaoActions.CHANGE, data: { dados: { ...manutencao.dados, ...{ numeroWhats: '', enviaWhats: enviaWhats } } } });
        }
    };

    function setarWhats() {
        let whats = formulario.getFieldValue().formWhats;
        dispatch({ type: manutencaoActions.CHANGE, data: { dados: { ...manutencao.dados, ...{ numeroWhats: whats, enviaWhats: true } } } });
    }

    async function enviarWhats(whats) {
        if (!dadosWhats === true) {
            let conectado = await conectar();
            /// numero da empresa deve ser um numero com codigo de area mais numero de telefone com 8 digitos
            if (conectado === true && (!!!manutencao?.dados?.cliente.telefones?.[0]?.psc_numero || manutencao?.dados?.cliente.telefones?.[0]?.psc_numero.length > 0)) {
                setExibirQR(false);
            }
            else if (!manutencao?.dados?.cliente.telefones?.[0]?.psc_numero || manutencao?.dados?.cliente.telefones?.[0]?.psc_numero.length === 0 && conectado === false) {
                notification.warning({ description: 'Adicione um ou mais numeros de remetente!', message: 'Aviso' });
                return;
            }
            else if (conectado === false && !!!manutencao?.dados?.cliente.telefones?.[0]?.psc_numero || manutencao?.dados?.cliente.telefones?.[0]?.psc_numero.length > 0) {
                gerarQRCode(whats);
            }
        }
        else {
            return;
        }
    }

    async function gerarQRCode(whats) {
        if (HasValue(whats)) {
            let base64 = (await api.get(`WhatsApp/GeraQrCodeWhats`)).data; // Pode passar qualquer string aqui
            setExibirQR(true);
            setBase64Image(base64);  // Atualiza o estado com o QR Code
            verificarConexao(whats);
        }
    }

    async function conectar() {
        let conectar = (await api.get('WhatsApp/WhatsConectado')).data;
        setConectado(conectar);
        return conectar;
    }

    async function verificarConexao(whats) {
        const timeout = Date.now() + (temporizador * 1000); // Define o tempo limite em segundos
        while (Date.now() < timeout) {
            let status = await conectar();
            if (status === true) {
                setExibirQR(false);
                console.log("Conectado!");
                notification.success({ description: 'Conectado!', message: 'Aviso' });
                return;
            }
            await new Promise((resolve) => setTimeout(resolve, 4500)); // Aguarda 4,5s antes de tentar novamente
        }
        gerarQRCode(whats); // Chama a função para gerar um novo QR Code
    }

    function removerCliente() {
        setPossuiAntecipacao(false);
        let clienteConsumidor = {
            pes_nome: 'CONSUMIDOR FINAL',
            cpfCnpj: ''
        }
        dispatch({ type: manutencaoActions.CHANGE, data: { dados: { ...manutencao.dados, ...{ cliente: clienteConsumidor } } } });
        setCliente(clienteConsumidor);
        setDadosAntecipacao([]);
        setSwitchState(false);
        setSwitchDadosConsumidor(false);
        setIgnorarDadosClienteDfe(false);
    }

    async function buscarDadosAntecipacao() {
        let dadosTemp = manutencao.dados.cliente;
        if (!!dadosTemp.pes_id) {
            let retorno = await api.get(`AntecipacaoClienteFornecedor/ListaAntecipacaoCliente?pessoaId=${dadosTemp.pes_id}`);
            if (!!retorno.data && retorno.data.length > 0) {
                let seq = 0;
                retorno.data.forEach((ant) => {
                    ant.key = seq;
                    seq++;
                });
                setPossuiAntecipacao(true);
                setDadosAntecipacao(retorno.data);
                setAbreModalAntecipacao(true);
            }
        }
    }

    useEffect(() => {
        if (switchState) {
            modalNFCEDestination();
        }
    }, [switchState]);

    function modalNFCEDestination() {
        Modal.confirm({
            icon: (
                <div style={{ textAlign: 'center' }}>
                    <ExclamationCircleOutlined style={{ fontSize: '80px', marginBottom: '20px', color: 'sandybrown' }} />
                    <div>
                        <div style={{ fontSize: '17px', marginBottom: '3px' }}>Atenção!</div>
                        <div style={{ fontSize: '14px', lineHeight: '1.2', color: 'gray' }}>
                            Para entrega a domicílio é necessário informar o Endereço de Entrega e o Transportador, deseja continuar?
                        </div>
                    </div>
                </div>
            ),
            okText: 'Informar Transportador',
            cancelText: 'Não',
            onOk() {
                setOpenModalTransportadora(true);
            },
            onCancel() {
                setSwitchState(false);
            },
        })
    }

    function handleToggleDelivery(value) {
        setSwitchState(value);
        if (value) {
            setSwitchDadosConsumidor(false);
            setIgnorarDadosClienteDfe(false);
        }
    }

    function handleToggleNaoInformar(value) {
        setSwitchDadosConsumidor(value);
        setIgnorarDadosClienteDfe(value);
        if (value) {
            setSwitchState(false);
        }
    }

    return (
        <>
            <Card
                className="hgCard"
                title={
                    <Typography.Title level={4} className="m-b-0 m-t-0">
                        <img src={require("../../assets/i-info.png")} alt="Dados do Cliente" style={{ verticalAlign: 'sub' }} /> DADOS DO CLIENTE
                    </Typography.Title>
                }
            >
                <Form form={formulario} name="formDadosCliente" layout="vertical">
                    <Row align="middle" gutter={[8, 0]}>
                        <Col span={24}>
                            <Row align="middle" justify="space-between" gutter={[8, 0]}>
                                <Col xs={17} sm={17} md={17} lg={17} xl={16} xxl={17} className="over-text">
                                    Cliente: <b>{cliente.pes_nome}</b>
                                </Col>
                                <Col className="btn-dados-cli">
                                    <Tooltip title="Editar Cliente (F2)" placement="top">
                                        <Button type="text" icon={<EditOutlined />} onClick={() => {
                                            setOpenModalBuscaCliente(true);
                                        }} />
                                    </Tooltip>
                                    <Tooltip title="Remover Cliente" placement="top">
                                        <Button type="text" icon={<DeleteOutlined />} onClick={() => removerCliente()} />
                                    </Tooltip>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            CPF/CNPJ: <b>{!!cliente.pef_cpf ? cliente.pef_cpf : (!!cliente.pej_cnpj ? cliente.pej_cnpj : !!cliente.cpfCnpj ? cliente.cpfCnpj : 'Não Informado')}</b>
                        </Col>
                        <Col span={24}>
                            {cliente?.pes_id && !switchDadosConsumidor &&
                                <Row gutter={[8, 0]}>
                                    <Col>
                                        <Switch onClick={(value) => handleToggleDelivery(value)} checked={switchState} />
                                    </Col>
                                    <Col>
                                        NFC-e com entrega a domicílio?
                                    </Col>
                                </Row>
                            }
                            {cliente?.pes_id && !switchState &&
                                <Row gutter={[8, 0]}>
                                    <Col>
                                        <Switch onClick={(value) => handleToggleNaoInformar(value)} checked={switchDadosConsumidor} />
                                    </Col>
                                    <Col>
                                        NFC-e NÃO Informar Dados do Consumidor?
                                    </Col>
                                </Row>
                            }

                            <Row gutter={[8, 0]}>
                                <Col>
                                    <Switch onClick={switchEmail} />
                                </Col>
                                <Col>
                                    NFC-e enviar por e-mail
                                </Col>
                            </Row>

                        </Col>
                        {!!dadosEmail === true &&
                            <Col span={24}>
                                <Form.Item className="m-b-0" name="formEmail">
                                    <Input name="email" value={email} placeholder="Informe o e-mail"
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </Form.Item>
                            </Col>
                        }
                        <Col span={24} className={dadosWhats && dadosEmail ? "m-t-5" : ""}>
                            <Row gutter={[8, 0]}>
                                <Col>
                                    <Switch onClick={switchWhats} />
                                </Col>
                                <Col>
                                    NFC-e enviar por WhatsApp
                                </Col>
                                {!!dadosWhats === true &&
                                    <Col>
                                        <Form.Item className="m-b-0" name="formWhats">
                                            <Input name="numeroWhats" value={numeroWhats} placeholder="Informe o Numero Whats"
                                                onChange={(e) => setNumeroWhats(e.target.value)}
                                                onBlur={() => setarWhats()}
                                            />
                                        </Form.Item>
                                    </Col>
                                }
                            </Row>
                        </Col>
                        {possuiAntecipacao &&
                            <Col span={24}>
                                <Button type="primary" onClick={() => buscarDadosAntecipacao()} className="m-t-5">
                                    Possui Antecipação
                                </Button>
                            </Col>
                        }
                    </Row>
                </Form>
            </Card>
            <ModalBuscaPessoaAutorizada exibirModalBuscaPessoaAutorizada={openModalBuscaPessoaAutorizada} fecharModalBuscaPessoaAutorizada={() => setOpenModalBuscaPessoaAutorizada(false)} dadosCliente={dadosCliente} />
            <ModalCliente exibirModalBuscaCliente={openModalBuscaCliente} fecharModalBuscaCliente={() => setOpenModalBuscaCliente(false)} setDadosCliente={setDadosCliente} dadosCliente={dadosCliente} />
            <ModalTransportadora dadosCliente={dadosCliente} exibirModalTransportadora={openModalTransportadora} setFrete={setFrete} fecharModalTransportadora={() => { setOpenModalTransportadora(false) }}
                setEnderecoDestino={setEnderecoDestino} setSwitchState={setSwitchState} />
            <Modal centered
                title={`Enviar por WhatsApp`}
                open={exibirQr}
                onCancel={onCloseModalQr}
                footer={[
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button key="cancel" onClick={() => onCloseModalQr()}>
                            Cancelar
                        </Button>
                    </div>
                ]}
                width={305} // Define a largura do modal (padrão é 520px)
                style={{ height: "320px" }} // Define a altura do corpo do modal
            >
                <ModalImagemQr centered isOpen={exibirQr} base64Image={base64Image} tempo={temporizador} />
            </Modal>
        </>
    );
}